export function mapFactorsAndCategories(factors) {
  return factors.reduce((acc, factor) => {
    acc[factor.category] = (acc[factor.category] ?? 0) + factor.value
    acc[factor.id] = factor.value
    return acc
  }, {})
}

export function getRiskTotal(risk = {}) {
  const summary = risk?.attribution?.summary
  if (!summary) {
    return null
  }

  return (summary.factors || 0) + (summary.specific || 0)
}
